/* eslint-disable no-prototype-builtins,prefer-template,no-restricted-syntax */
import StorageApi from '../api/storage';
import {VERSION} from '../configs';
import {STORAGE_USER_NAMESPACE} from '../constants/users';
import {STORAGE_SESSION_NAMESPACE} from '../constants/sessions';
import {USER_AUTHORITY_LEVEL, USER_ROLE} from '../constants/user';

class UtilsHelper {
  static serialize(object, prefix) {
    const str = [];

    for (const p in object) {
      if (object.hasOwnProperty(p)) {
        if (typeof object[p] === 'object') {
          str.push(encodeURIComponent(p) + '=' + JSON.stringify(object[p]));
        } else {
          str.push(encodeURIComponent(p) + '=' + encodeURIComponent(object[p]));
        }
      }
    }

    const string = str.join('&');
    const s = prefix ? `${prefix}${string}` : string;

    return s;
  }

  static randomStr(length = 7) {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  }

  static setAppVersion() {
    const currentVersion = StorageApi.local.get('VERSION');

    if (!currentVersion || VERSION !== currentVersion) {
      StorageApi.delete(STORAGE_USER_NAMESPACE);
      StorageApi.delete(STORAGE_SESSION_NAMESPACE);
    }

    StorageApi.local.set('VERSION', VERSION);
  }

  static priceFormat(num) {
    return ('' + num).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
  }

  static isAllowedFormat(format, allowedFormats = []) {
    return allowedFormats.includes(format.toLowerCase());
  }

  static isAdmin(userData = {}) {
    return userData.authorityLevel >= USER_AUTHORITY_LEVEL.ADMIN || userData.role === USER_ROLE.ADMINISTRATOR;
  }
}

export default UtilsHelper;

export function pluralize(n, titles) {
  return titles[
    // eslint-disable-next-line no-nested-ternary
    (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)
  ];
}
